import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Text, TextArea } from 'react-form';

import InputBase from 'forms/InputBase';
import InputBlock from 'forms/InputBlock';

import { CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';

class StripeInput extends InputBase {

  onChange = status => {
    if (status.error) {
      //this.props.formApi.setError(this.props.type, status.error);
    }
    else {
      //this.props.formApi.setError(this.props.type, undefined);
    }

    return this.props.onChange(this.props.type, status);
  }

  renderInput() {
    switch(this.props.type) {
      case 'cardNumber':
        return <CardNumberElement onChange={this.onChange} />;
      case 'cardExpiry':
        return <CardExpiryElement onChange={this.onChange} />;
      case 'cardCvc':
        return <CardCVCElement onChange={this.onChange} />;
    }
  }

  render() {
    return (
      <InputBlock size={this.props.size} className={`-${this.props.type}`}>
        {this.renderLabel()}
        {this.renderInput()}
        {this.props.children}
        {this.renderErrors(this.props.type)}
      </InputBlock>
    )
  }

}

StripeInput.propTypes = {
  label:    PropTypes.string.isRequired,
  labelSecondary: PropTypes.string,
  type:     PropTypes.string.isRequired,
  size:     PropTypes.string,
  children: PropTypes.element,
  errors:   PropTypes.object,
  formApi:  PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default StripeInput;
